module.exports = __webpack_public_path__ + "img/card-bg-11.3ff7cae8.jpg";